import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import { BrowserRouter as Router } from 'react-router-dom'
import VConsole from 'vconsole'
import { devtools } from 'stook-devtools'
import SentryInit from './utils/sentry'
import Loading from './components/loading'

const App = lazy(() => import(/* webpackChunkName: "App" */ './App'))

SentryInit()

if (process.env.REACT_APP_DEPLOY_ENV !== 'production') {
  // eslint-disable-next-line no-new
  new VConsole({})
}

if (process.env.NODE_ENV !== 'production') {
  devtools.init()
}

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Loading show />}>
      <Router basename='/insurance/'>
        <App />
      </Router>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
)
